import React from "react";
import PhoneInput from "react-phone-input-2";
import { usePhoneInput } from "../../../../Hooks";
import { toast } from "react-toastify";
import { APIErrorCondition } from "../../../../constants";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function PhoneNumber(_ref) {
  var setCaptureUserMobile = _ref.setCaptureUserMobile,
    redeemNowClickedHandler = _ref.redeemNowClickedHandler,
    _ref$isMobileNumberMi = _ref.isMobileNumberMissing,
    isMobileNumberMissing = _ref$isMobileNumberMi === void 0 ? false : _ref$isMobileNumberMi,
    setIsMobileNumberMissing = _ref.setIsMobileNumberMissing,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    winnreAuth = _ref.winnreAuth;
  var _usePhoneInput = usePhoneInput(),
    _usePhoneInput$state = _usePhoneInput.state,
    currentMobileNumberIsValid = _usePhoneInput$state.isValid,
    currentMobile = _usePhoneInput$state.mobile,
    currentCountry = _usePhoneInput$state.country,
    currentMobileHasError = _usePhoneInput$state.mobileHasError,
    isCurrentMobileInputFocused = _usePhoneInput$state.isInputFocused,
    currentMobileOnChange = _usePhoneInput.onChange,
    currentMobileValidtor = _usePhoneInput.validator,
    setCurrentMobileIsTouched = _usePhoneInput.setIsTouched,
    getCurrentMobileWithoutCountryCode = _usePhoneInput.getMobileWithoutCountryCode,
    setCurrentMobileInputFocused = _usePhoneInput.setInputFocused;
  var submitHandler = function submitHandler() {
    var mobileNumber = getCurrentMobileWithoutCountryCode();
    var countryCode = currentCountry === null || currentCountry === void 0 ? void 0 : currentCountry.dialCode;
    if (winnreAuth) {
      winnreAuth({
        method: "POST",
        url: "/winnre/user/add-mobile-number?mobileNumber=".concat(mobileNumber, "&countryCode=").concat(countryCode)
      }).then(function (res) {
        if ((res === null || res === void 0 ? void 0 : res.status) === APIErrorCondition) {
          toast.error(res.message);
        } else {
          var _redux$authActions;
          if (redux !== null && redux !== void 0 && redux.dispatch && redux !== null && redux !== void 0 && (_redux$authActions = redux.authActions) !== null && _redux$authActions !== void 0 && _redux$authActions.setUserMobile) {
            redux.dispatch(redux.authActions.setUserMobile({
              mobileCountryCode: countryCode,
              mobileNumber: mobileNumber
            }));
          }
          if (isMobileNumberMissing) {
            var _redux$authActions2;
            if (redux !== null && redux !== void 0 && redux.dispatch && redux !== null && redux !== void 0 && (_redux$authActions2 = redux.authActions) !== null && _redux$authActions2 !== void 0 && _redux$authActions2.closeLoginModal) {
              redux.dispatch(redux.authActions.closeLoginModal());
            }
            setIsMobileNumberMissing && setIsMobileNumberMissing(false);
          } else if (redeemNowClickedHandler) {
            redeemNowClickedHandler(mobileNumber);
          }
        }
      });
    } else {
      var _redux$authActions3;
      if (redux !== null && redux !== void 0 && redux.dispatch && redux !== null && redux !== void 0 && (_redux$authActions3 = redux.authActions) !== null && _redux$authActions3 !== void 0 && _redux$authActions3.setUserMobile) {
        redux.dispatch(redux.authActions.setUserMobile({
          mobileCountryCode: countryCode,
          mobileNumber: mobileNumber
        }));
      }
      if (isMobileNumberMissing) {
        var _redux$authActions4;
        if (redux !== null && redux !== void 0 && redux.dispatch && redux !== null && redux !== void 0 && (_redux$authActions4 = redux.authActions) !== null && _redux$authActions4 !== void 0 && _redux$authActions4.closeLoginModal) {
          redux.dispatch(redux.authActions.closeLoginModal());
        }
        setIsMobileNumberMissing && setIsMobileNumberMissing(false);
      } else if (redeemNowClickedHandler) {
        redeemNowClickedHandler(mobileNumber);
      }
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "py-4 px-6 flex flex-col",
    children: [!isMobileNumberMissing && /*#__PURE__*/_jsx("p", {
      className: "text-center font-semibold",
      children: "Please enter your phone number to help us serve you better"
    }), isMobileNumberMissing && /*#__PURE__*/_jsx("p", {
      className: "text-center font-semibold",
      children: "Share your phone number to stay connected and receive the latest updates on WA"
    }), /*#__PURE__*/_jsxs("div", {
      className: " w-[70%] mx-auto mt-4 mb-2 md:mb-5'\n          relative",
      children: [/*#__PURE__*/_jsx(PhoneInput, {
        country: "in",
        countryCodeEditable: false,
        containerClass: "mx-auto peer py-3 border border-gray-300 focus:outline-none rounded-md focus:border-gray-500 focus:shadow-sm w-full  h-12 placeholder-transparent",
        containerStyle: {
          width: "100%",
          border: "2px solid grey !important",
          outline: "none"
        },
        buttonStyle: {
          backgroundColor: "white",
          border: "none"
        },
        inputStyle: {
          width: "100%",
          height: "auto",
          border: "none",
          outline: "none",
          paddingLeft: "44px",
          fontSize: "16px"
        },
        isValid: currentMobileValidtor,
        onChange: currentMobileOnChange,
        value: currentMobile,
        enableSearch: true,
        onBlur: function onBlur() {
          setCurrentMobileIsTouched(true);
          setCurrentMobileInputFocused(false);
        },
        onFocus: function onFocus() {
          return setCurrentMobileInputFocused(true);
        },
        inputClass: "border border-gray-300"
      }), currentMobileHasError && /*#__PURE__*/_jsx("p", {
        className: " text-left text-sm mt-1 font-Roboto text-red-400",
        children: "Please enter a valid number"
      })]
    }), /*#__PURE__*/_jsx("button", {
      disabled: !currentMobileNumberIsValid,
      className: "disabled:bg-gray-300 bg-primary px-5 mt-2 py-1.5 text-white text-center mr-2 rounded self-center",
      onClick: submitHandler,
      children: "Submit"
    })]
  });
}
export default PhoneNumber;